import React, { useState } from 'react';
import useApiStable from '../utils/useApiStable';

const Register = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [awaitingVerification, setAwaitingVerification] = useState(false);
  const [resendStatus, setResendStatus] = useState('');
  const [isResending, setIsResending] = useState(false);
  const api = useApiStable();

  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!firstName.trim()) {
      setError('Bitte geben Sie einen Vornamen ein.');
      return;
    }

    if (!lastName.trim()) {
      setError('Bitte geben Sie einen Nachnamen ein.');
      return;
    }

    if (!validateEmail(email)) {
      setError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }

    if (password.length < 6) {
      setError('Das Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }

    try {
      await api.fetchRaw('/auth/register', {
        method: 'POST',
        body: JSON.stringify({
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          email: email.trim(),
          password: password,
        })
      });

      setAwaitingVerification(true);
    } catch (err) {
      setError(err.message || 'Registrierung fehlgeschlagen');
    }
  };

  const handleResend = async () => {
    setIsResending(true);
    setResendStatus('');
    try {
      await api.fetchRaw('/auth/resend-verification', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim() })
      });
      setResendStatus('E-Mail wurde erneut gesendet. Bitte prüfen Sie Ihr Postfach.');
    } catch {
      setResendStatus('E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.');
    } finally {
      setIsResending(false);
    }
  };

  if (awaitingVerification) {
    return (
      <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>Registrierung</h2>

          <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '16px', borderRadius: '4px', marginBottom: '24px', fontSize: '0.9em' }}>
            Registrierung erfolgreich! Wir haben eine Bestätigungs-E-Mail an <strong>{email.trim()}</strong> gesendet.
            Bitte prüfen Sie Ihr Postfach und klicken Sie auf den Link, um Ihr Konto zu aktivieren.
          </div>

          <p style={{ fontSize: '0.9em', color: '#555', marginBottom: '12px' }}>
            Keine E-Mail erhalten?
          </p>

          {resendStatus && (
            <div style={{
              background: resendStatus.includes('erneut gesendet') ? '#e8f5e9' : '#ffebee',
              color: resendStatus.includes('erneut gesendet') ? '#2e7d32' : '#c62828',
              padding: '10px',
              borderRadius: '4px',
              marginBottom: '12px',
              fontSize: '0.9em'
            }}>
              {resendStatus}
            </div>
          )}

          <button
            onClick={handleResend}
            disabled={isResending}
            style={{
              width: '100%',
              padding: '10px',
              background: isResending ? '#90a4ae' : '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '0.95em',
              cursor: isResending ? 'not-allowed' : 'pointer',
              fontWeight: '500',
              marginBottom: '20px'
            }}
          >
            {isResending ? 'Wird gesendet...' : 'Bestätigungs-E-Mail erneut senden'}
          </button>

          <div style={{ textAlign: 'center', fontSize: '0.9em' }}>
            <a href="/login" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Zum Login
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
      <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Registrierung</h2>

        {error && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '20px',
            fontSize: '0.9em'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Vorname*
            </label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Nachname*
            </label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              E-Mail*
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Passwort* (mind. 6 Zeichen)
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Passwort bestätigen*
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1em',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Registrieren
          </button>

          <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '0.9em' }}>
            Bereits registriert?{' '}
            <a href="/login" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Zum Login
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
